export default __webpack_public_path__ + "static/media/bitmoji_hi.40ecb594.png";